/* eslint-disable @typescript-eslint/no-explicit-any */

const EthIcon = ({ props }: any) => (
    <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9.99785 1.25L9.80664 1.6488V13.2201L9.99785 13.3372L18.7451 10.1623L9.99785 1.25Z"
            fill="#343434"
        />
        <path
            d="M9.99743 1.25L1.25 10.1623L9.99743 13.3372V7.72083V1.25Z"
            fill="#8C8C8C"
        />
        <path
            d="M9.99741 14.354L9.88965 14.4346V18.5565L9.99741 18.7497L18.75 11.1807L9.99741 14.354Z"
            fill="#3C3C3B"
        />
        <path
            d="M9.99743 18.7497V14.354L1.25 11.1807L9.99743 18.7497Z"
            fill="#8C8C8C"
        />
        <path
            d="M9.99707 13.3371L18.7443 10.1621L9.99707 7.7207V13.3371Z"
            fill="#141414"
        />
        <path
            d="M1.25 10.1621L9.99743 13.3371V7.7207L1.25 10.1621Z"
            fill="#393939"
        />
    </svg>
)
export default EthIcon
